import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { StaticIdentifiers } from 'src/constants/cluster-status';
import { Button, Field, Icon, Label, Select } from '@innovationnorway/cl-react';
import { useSearchParams } from 'react-router-dom';
import useDownloadGoalOverviewReport from 'src/features/siva/reporting/hooks/useDownloadGoalOverviewReport';
import saveAs from 'file-saver';
import useSivaYearList from 'src/hooks/use-year-list-reporting';
const pageSearchParams = {
  year: 'year',
  actorType: 'actorType',
};
const ExtractGoalAccomplishment: React.FC = () => {
  const { t: tCommon } = useTranslation();
  const { t: tPageTitles } = useTranslation('pageTitles');
  const { t: tSiva } = useTranslation('siva');
  const [searchParams, setSearchParams] = useSearchParams();
  const actorType = searchParams.get(pageSearchParams.actorType) || StaticIdentifiers.SivaBusinessGarden;
  const [selectedYear, setSelectedYear] = useState<string | undefined>(undefined);
  const yearList = useSivaYearList(2023);
  const { fetchReport } = useDownloadGoalOverviewReport(
    actorType,
    selectedYear === '' ? undefined : parseInt(selectedYear || ''),
  );
  const handleDownloadReportOnClick = async () => {
    const file = await fetchReport.mutateAsync();
    saveAs(file.data, file.fileName);
  };
  return (
    <ContentPage
      title={tSiva('export.goalAccomplishment.header')}
      documentTitle={tPageTitles('sivaReporting')}
    >
      <div className="display--flex gap--3 align-items--center">
        <Field>
          <Label>{tSiva('export.reportingYear')}</Label>
          <Select
            name="year"
            value={selectedYear ?? 'none'}
            className="margin-0-on-all-children"
            onChange={(event) => setSelectedYear(event.target.value)}
          >
            {selectedYear === undefined && (
              <Select.Option value="none" disabled>
                {tCommon('selectYear')}
              </Select.Option>
            )}
            <Select.Option value="">{tCommon('allYears')}</Select.Option>
            {yearList.map((year) => (
              <Select.Option key={year} value={year.toString()}>
                {year}
              </Select.Option>
            ))}
          </Select>
        </Field>
        <Field>
          <Label>{tCommon('type')}</Label>
          <Select
            name={tCommon('type')}
            value={actorType}
            onChange={(event) =>
              setSearchParams(
                (prevValue) => {
                  const year = prevValue.get(pageSearchParams.year) || '';
                  return { actorType: event.target.value, year };
                },
                { replace: true },
              )
            }
          >
            <Select.Option value={StaticIdentifiers.SivaBusinessGarden}>
              {tCommon('businessGarden')}
            </Select.Option>
            <Select.Option value={StaticIdentifiers.SivaIncubator}>{tCommon('incubator')}</Select.Option>
          </Select>
        </Field>
        <Button type="button" variant="tertiary" onClick={handleDownloadReportOnClick}>
          <Icon className={'margin-right--1'} prefix="fasr" iconName="file-export" />
          {`${tSiva('export.goalAccomplishment.exportButton')} ${
            actorType === StaticIdentifiers.SivaBusinessGarden
              ? tCommon('businessGarden').toLowerCase()
              : tCommon('incubator').toLowerCase()
          }`}
        </Button>
      </div>
    </ContentPage>
  );
};
export default ExtractGoalAccomplishment;
